module.exports = __webpack_public_path__ + "assets/plus-orange-25753e45971ceafba156ae4a57e12c37.svg";